// extracted by mini-css-extract-plugin
export default {"root":"AboutPage_root__v6UpL","mainContent":"AboutPage_mainContent__lB0Uv"};